import React, { useCallback, useEffect, useState } from "react";
import WebLayout from "../../../layout/WebLayout";
import ContactDetails from "../../../components/ContactDetails";
import Information from "../../../components/Information";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../stores";
import profileAction from "../../../stores/actions/profileAction";
import ProgressBar from "@ramonak/react-progress-bar";
import moment from "moment";
import KYCDetails from "../../../components/KYCDetails";
import BankDetails from "../../../components/BankDetails";
import { LOGO } from "../../../utils/Constants";
import ReviewRating from "../../../components/ReviewRating";

function SellerProfile() {
  const [activeTab, setActiveTab] = useState<number>(1);
  const dispatch = useDispatch<any>();
  const handleTabClick = (tabNumber: number) => {
    setActiveTab(tabNumber);
  };

  const { profileDetails } = useSelector((state: RootState) => state.auth);

  const getProfileDetails = useCallback(async () => {
    await dispatch(profileAction.getProfile());
  }, []);

  useEffect(() => {
    getProfileDetails();
  }, [getProfileDetails]);

  return (
    <WebLayout pageName={"SellerProfile"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-12">
              <div className="card mb-3 ">
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-2">
                  <div className="flex-grow-1 mt-2">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">
                        <h4 className="mb-2">
                          {profileDetails?.name_of_entity} (
                          {profileDetails?.account_id})
                        </h4>

                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-pen"></i>{" "}
                            {profileDetails?.rep_name}
                          </li>
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-map"></i>{" "}
                            {profileDetails?.stateName}
                          </li>
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-calendar-alt"></i>{" "}
                            {moment(profileDetails?.created_at).format("lll")}
                          </li>
                        </ul>
                      </div>

                      {profileDetails?.account_status === "ACTIVATE" ? (
                        <a
                          href="javascript:void(0)"
                          className="btn btn-success text-nowrap">
                          <i className="bx bx-user-check me-1"></i>
                          Verified
                        </a>
                      ) : (
                        <a
                          href="javascript:void(0)"
                          className="btn btn-danger text-nowrap">
                          <i className="bx bx-user-check me-1"></i>
                          Not Verified
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <hr className="m-0" />
                <div className="card-body p-0">
                  {activeTab === 1 && (
                    <ContactDetails
                      getSellerData={profileDetails}
                      getProfileDetails={getProfileDetails}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default SellerProfile;
